import { useEffect } from "react";
import LegalLayout, { H2, P, UL } from "@/components/site/LegalLayout";
import { AGENCY } from "@/data/content";

export default function Terms() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <P>
        These Terms of Service ("Terms") govern your use of the Doug Jones Insurance and Financial Planning Agency website (anicobr.com)
        and our communications with you. By using our website or submitting a form, you agree to these Terms.
      </P>

      <H2>Website Use</H2>
      <P>
        Information on this website is provided for general informational purposes and does not constitute an offer
        or binding contract of insurance. Coverage is subject to the terms, conditions, and approval of the applicable
        insurance carrier. Quotes are estimates and may change based on underwriting.
      </P>

      <H2>SMS / Text Messaging Terms (A2P 10DLC)</H2>
      <P>
        By providing your mobile number and checking the SMS consent box on our forms, you expressly consent to
        receive text messages from Doug Jones Insurance and Financial Planning Agency.
      </P>
      <UL>
        <li><strong>Program description:</strong> We send conversational and account-related messages regarding your quote, policy, servicing, and account updates.</li>
        <li><strong>Message frequency:</strong> Message frequency varies based on your interactions with us.</li>
        <li><strong>Cost:</strong> Message and data rates may apply, per your mobile carrier's plan.</li>
        <li><strong>Opt out:</strong> Reply <strong>STOP</strong> to any message to unsubscribe at any time.</li>
        <li><strong>Help:</strong> Reply <strong>HELP</strong> for assistance, or contact us at {AGENCY.phone}.</li>
        <li><strong>Consent is not a condition of purchase.</strong> You may still obtain a quote or purchase coverage without agreeing to receive texts.</li>
        <li><strong>Carriers:</strong> Mobile carriers are not liable for delayed or undelivered messages.</li>
      </UL>
      <P>
        Your consent to receive text messages and the mobile information collected for messaging are never shared
        with third parties for marketing purposes. See our <a href="/privacy" className="text-brand-green underline">Privacy Policy</a> for details.
      </P>

      <H2>Licensing</H2>
      <P>
        Doug Jones Insurance and Financial Planning Agency is a licensed insurance agency operating in the State of Louisiana. Insurance
        products are offered through licensed agents and are subject to state regulations.
      </P>

      <H2>Limitation of Liability</H2>
      <P>
        We are not liable for any indirect or consequential damages arising from your use of this website. All
        coverage determinations are made by the issuing insurance carrier.
      </P>

      <H2>Changes to These Terms</H2>
      <P>
        We may update these Terms from time to time. Continued use of the website after changes constitutes acceptance
        of the updated Terms.
      </P>

      <H2>Contact Us</H2>
      <P>
        Doug Jones Insurance and Financial Planning Agency · {AGENCY.address} · Phone: {AGENCY.phone} · Email: {AGENCY.email}
      </P>
    </LegalLayout>
  );
}
